import { SystemStyleObject } from '@chakra-ui/react';

const baseStyle: SystemStyleObject = {
  field: {
    borderWidth: 1,
    borderColor: `rgba(104, 48, 97, 0.14)`,
    background: `white`,
    borderRadius: 10,
    px: 5,
    transition: `0.3s`,
    _focus: {
      borderWidth: 1,
      borderColor: `brand.orange`,
      boxShadow: `0 0 0 4px rgba(243, 146, 0, 0.12)`,
    },
  },
};

const sizes: SystemStyleObject = {
  sm: {
    field: {
      h: 12,
    },
  },
  md: {
    field: {
      h: 16,
    },
  },
};

const defaultProps: SystemStyleObject = {
  size: `sm`,
};

export const Input = {
  parts: [`addon`, `field`, `element`],
  baseStyle,
  sizes,
  defaultProps,
};
